import $ from "jquery";

// Initialize tabs on page load
$(document).ready(function () {
  // Show first tab and panel for each tab group
  $(".js-tab-title-first").each(function () {
    const $firstTab = $(this);
    const panelId = $firstTab.attr("aria-controls");

    // Set first tab as active only on desktop
    if (window.innerWidth >= 992) {
      $firstTab.addClass("current").attr("aria-selected", "true");
      // Show corresponding panel (desktop)
      $("#" + panelId).show();
    } else {
      // On mobile, don't set any tab as active initially
      $firstTab.removeClass("current").attr("aria-selected", "false");
    }
  });
});

// Handle tab clicks
$(".js-tab-title").on("click", function (e) {
  e.preventDefault();

  const $clickedTab = $(this);
  const tabGroupId = $clickedTab.attr("data-tab");
  const panelId = $clickedTab.attr("aria-controls");
  const tabIndex = $clickedTab.attr("id").match(/tab(\d+)/)[1];
  const mobileContentId = "mobile-panel-" + tabIndex + "-" + tabGroupId;

  // Check if we're on mobile
  const isMobile = window.innerWidth < 992;

  if (isMobile) {
    // Mobile accordion behavior
    const $mobileContent = $("#" + mobileContentId);
    const isCurrentlyOpen = $mobileContent.is(":visible");

    if (isCurrentlyOpen) {
      // Close if already open
      $clickedTab.removeClass("current").attr("aria-selected", "false");
      $mobileContent.slideUp(300);
    } else {
      // Close all other mobile content in this group first
      $(`.js-tab-title-${tabGroupId}`)
        .removeClass("current")
        .attr("aria-selected", "false");
      $(`.mobile-tab-content`).slideUp(300);

      // Then open clicked tab content
      $clickedTab.addClass("current").attr("aria-selected", "true");
      $mobileContent.slideDown(300);
    }
  } else {
    // Desktop tab behavior
    // Don't do anything if this tab is already active
    if ($clickedTab.hasClass("current")) {
      return;
    }

    // Remove current state from all tabs in this group
    $(`.js-tab-title-${tabGroupId}`)
      .removeClass("current")
      .attr("aria-selected", "false");

    // Hide all panels in this group
    $(`.panel-${tabGroupId}`).hide();

    // Set clicked tab as current
    $clickedTab.addClass("current").attr("aria-selected", "true");

    // Show corresponding panel
    $("#" + panelId).show();
  }
});

// Handle window resize to reset states
$(window).on("resize", function () {
  const isMobile = window.innerWidth < 992;

  if (!isMobile) {
    // Hide all mobile content when switching to desktop
    $(".mobile-tab-content").hide();

    // Ensure first tab is active on desktop
    $(".js-tab-title-first").each(function () {
      const $firstTab = $(this);
      const panelId = $firstTab.attr("aria-controls");
      const tabGroupId = $firstTab.attr("data-tab");

      // Reset all tabs in group
      $(`.js-tab-title-${tabGroupId}`)
        .removeClass("current")
        .attr("aria-selected", "false");
      $(`.panel-${tabGroupId}`).hide();

      // Activate first tab
      $firstTab.addClass("current").attr("aria-selected", "true");
      $("#" + panelId).show();
    });
  } else {
    // On mobile, hide desktop panels and reset mobile content
    $(".tab__text-content").hide();
    $(".mobile-tab-content").hide();

    // Show first mobile content for each group
    $(".js-tab-title-first").each(function () {
      const $firstTab = $(this);
      const tabIndex = $firstTab.attr("id").match(/tab(\d+)/)[1];
      const tabGroupId = $firstTab.attr("data-tab");

      // Reset tabs
      $(`.js-tab-title-${tabGroupId}`)
        .removeClass("current")
        .attr("aria-selected", "false");

      // Activate first tab and show its mobile content
      $firstTab.addClass("current").attr("aria-selected", "true");
      $("#mobile-panel-" + tabIndex + "-" + tabGroupId).show();
    });
  }
});

// Handle keyboard navigation
$(".js-tab-title").on("keydown", function (e) {
  // Enter or Space key
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    $(this).click();
  }
});

// Handle focus for accessibility
$(".js-tab-title").on("focus", function () {
  // Only trigger click if not activated by mouse
  if (!$(this).data("mouseDown")) {
    $(this).click();
  }
});

// Track mouse interactions to prevent focus-click conflicts
$(".js-tab-title")
  .on("mousedown", function () {
    $(this).data("mouseDown", true);
  })
  .on("mouseup", function () {
    $(this).removeData("mouseDown");
  });
